import React from 'react'
import PropTypes from 'prop-types'

export const ErrorControl = ({ error }) =>
  error ? <wb-control-error>{error}</wb-control-error> : null

ErrorControl.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}
